/* eslint-disable react/prop-types */
import React from 'react'
import styled from "styled-components"


const Container = styled.div`
  display: inline-block;
  background: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.foregroundColor};
  border: 1px solid ${props => props.theme.borderColor};
  margin-top: 0;
  padding: 2px 12px 0;
  border-radius: ${props => props.theme.borderRadius};
  font-weight: 600;
  font-size: 11px;
  line-height: 16px;
  text-transform: uppercase;

  span{
    padding-top: 2px;
  }
`

const Pill = ({ title, type="default" }) => {

  const pill = {
    default: {backgroundColor: '#F6FCFF', foregroundColor: '#728F9E', borderColor: '#09A5DB1A', borderRadius: '80px'},
    "coming-soon": { backgroundColor: '#F6FCFF', foregroundColor: '#728F9E', borderColor: '#09A5DB1A', borderRadius: '4px' },
  }

  return (
    <Container theme={pill[type]}>
      <span>{title}</span>
    </Container>
  )
}


export default Pill